<template>
  <main-layout>
    <div class="p-4">
      <h1 class="text-primary">{{ elm.titre }}</h1>
      <router-link :to="`/lecon/${$route.params.niveau}`">
        <button type="button" class="btn btn-secondary p-1">Retour au menu</button>
      </router-link>
      <hr/>
      <div v-if="elm.video"
           class="bg-light p-4 text-center d-block content"
           style="max-width: 800px;margin: 1.5rem auto">
        <div style="position:relative;padding-top:56.25%;">
          <iframe id="video2"
                  :src="`https://www.youtube.com/embed/${elm.video}?modestbranding=1&fs=0&rel=0`"
                  style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
        </div>
      </div>
      <div v-if="elm.contenu" class="content" v-html="formatContenu(elm.contenu)"></div>
    </div>
    <a :href="imageProps.link">
      <b-img :src="getImg()" :alt="imageProps.img"></b-img>
    </a>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/Nav/MainLayout";
import {Lecons} from "@/js/caller";

const pub = {
  b1: {
    img      : "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_B1.jpg",
    imgMobile: "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_B1_mini.jpg",
    link     : "https://www.luqei.com/b1.php?landing=TRUE"
  },
  b2: {
    img      : "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_B2.jpg",
    imgMobile: "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_B2_mini.jpg",
    link     : "https://www.luqei.com/b2.php?landing=TRUE"
  },
  c1: {
    img      : "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_C1.jpg",
    imgMobile: "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_C1_mini.jpg",
    link     : "https://www.luqei.com/c1.php"
  },
  c2: {
    img      : "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur.jpg",
    imgMobile: "https://www.luqei.com/images/landing/prepare_ton_examen_avec_le_professeur_mini.jpg",
    link     : "https://www.luqei.com/c2.php?landing=TRUE"

  }
}

export default {
  name      : "LeconElemVue",
  components: {MainLayout},
  data() {
    const niveau = this.$route.params.niveau;
    return {
      elm: {},
      imageProps: {
        ...pub[niveau]
      }
    }
  },
  methods: {
    formatContenu(contenu) {
      return contenu.replace(/(src=")(.*)(.jpg")/g, "$1https://www.luqei.com$2$3")
    },
    getImg() {
      return this.imageProps[screen.width < 576 ? 'imgMobile' : 'img']
    }
  },
  created() {
    Lecons.Get(this.$route.params.id).then(res => {
      this.elm = res;
    })
  }
}
</script>

<style scoped>
.content {
  max-width: 1400px;
  margin: auto;
}
img {
  width: 100%;
  max-width: 1200px;
  margin: auto;
  display: block;
}
</style>